import React from "react";
import { OperatorUsersProvider } from "./OperatorUsersContext";
import OperatorUsersList from "./OperatorUsersList";
import OperatorUserAccForm from "./OperatorUsersForm";
import OperatorUserRoles from "./OperatorUserRoles";
import OperatorUserAgencies from "./OperatorUsersAgencies";

const OperatorUsersPage = () => {
    return (
        <OperatorUsersProvider>
            <OperatorUsersList/>
            <OperatorUserAccForm/>
            <OperatorUserRoles/>
        </OperatorUsersProvider>
    )
};

export default OperatorUsersPage;